import request from '../utils/request'
// 侧边栏
export function julihemenulist (data) {
  return request({
    url: '/api/portal/julihe/menu',
    method: 'post',
    data
  })
}
// 首页
export function getbannerlist (data) {
  return request({
    url: '/api/portal/julihe/slides',
    method: 'post',
    data
  })
}
export function contactmeall (params) {
  return request({
    url: '/api/portal/julihe/new_subCategories',
    method: 'get',
    params
  })
}
export function gethomemsg (params) {
  return request({
    url: '/api/portal/julihe/index',
    method: 'get',
    params
  })
}
// 成功案例
export function getanlilist (params) {
  return request({
    url: '/api/portal/julihe/category_posts',
    method: 'get',
    params
  })
}
// 联系我们
export function getcontactmebackimg (params) {
  return request({
    url: '/api/portal/julihe/category_detail',
    method: 'get',
    params
  })
}
export function getcontactmelist (params) {
  return request({
    url: '/api/portal/julihe/contact',
    method: 'get',
    params
  })
}
// 企业荣誉
export function getrongyubackimg (params) {
  return request({
    url: '/api/portal/julihe/honor',
    method: 'get',
    params
  })
}
export function rongyulist (params) {
  return request({
    url: '/api/portal/julihe/category_posts',
    method: 'get',
    params
  })
}
// 文章列表
export function articleall (params) {
  return request({
    url: '/api/portal/julihe/category_posts',
    method: 'get',
    params
  })
}
// 文章详情
export function articlemsg (params) {
  return request({
    url: '/api/portal/julihe/read',
    method: 'get',
    params
  })
}



// WEBPACK FOOTER //
// ./src/api/jslihe.js